import type { ChannelAsset } from '../../../data/channel/types';
import { MediaType } from '../../../data/compat/tvpil';
import { createPager, createSearchAssetFilter } from '../../factories';
import { phoenixConfig } from '../../network';
import { KalturaLiveAsset } from '../../objects';
import { processChannel } from '../../processing/channel';
import { fetchAssetList } from '../../services';

export async function fetchChannels() {
  const { objects, totalCount } = await fetchAssetList<KalturaLiveAsset>({
    filter: createSearchAssetFilter({
      kSql: `(and asset_type='${phoenixConfig.assetsMediaTypes[MediaType.Linear]}')`,
    }),
    pager: createPager({
      pageIndex: 1,
      pageSize: 500,
    }),
  });

  const assetMap = new Map<number, KalturaLiveAsset>();
  const channelMap = new Map<number, ChannelAsset>();

  const channels: Array<ChannelAsset> = [];

  for (let i = 0; i < objects.length; i++) {
    const asset = objects[i];
    const channel = processChannel(asset);

    assetMap.set(asset.id, asset);
    channelMap.set(channel.id, channel);

    channels.push(channel);
  }

  return {
    assetMap,
    channels,
    channelMap,
    objects, // backward compatibility, in order to be able to create Linear
    totalCount: totalCount,
  };
}
